var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3284 0V4.125H10.2346C7.42961 4.125 5.07836 6.47625 5.07836 9.28125V11.3438C5.07836 14.1488 6.89336 16.4587 9.57461 17.16L20.1346 19.8825C20.7121 20.0475 21.5371 21.0788 21.5371 21.6975V23.76C21.5371 24.3375 21.0834 24.7913 20.5059 24.7913H10.1934C9.83507 24.7898 9.48201 24.7051 9.16211 24.5437V20.6663H5.03711V24.7913C5.03711 26.1938 5.86211 27.39 6.85211 28.0087C7.80086 28.6688 8.99711 28.9163 10.1934 28.9163H13.2871V33.0413H17.4121V28.9163H20.5059C23.3521 28.9163 25.6621 26.6063 25.6621 23.76V21.6975C25.6621 18.8925 23.8471 16.5825 21.1659 15.8812L10.6059 13.1588C10.0284 12.9938 9.20336 11.9625 9.20336 11.3438V9.28125C9.20336 8.70375 9.65711 8.25 10.2346 8.25H20.5471C21.0009 8.25 21.4134 8.415 21.5784 8.4975V12.375H25.7034V8.25C25.7034 6.8475 24.8784 5.65125 23.8884 5.0325C22.9396 4.3725 21.7434 4.125 20.5471 4.125H17.4534V0H13.3284Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollar_icon.3dfeb943ec48fbc8f558e5b8c80168fe.svg";
export { ForwardRef as ReactComponent };